import { Command, CommandPaletteDialog } from '@st/theme'
import { Organization } from '@st/sdk'
import { useMemo } from 'react'

type Props = {
  onClose: () => void
  onCopyOrganizationId: (organizationId: string) => void
  organization: Organization
}
export function FolderListCommandPallette({ organization, onClose, onCopyOrganizationId }: Props) {
  const commands: Command[] = useMemo(() => {
    return [
      {
        id: 'organization-id',
        label: `Organization ID: ${organization.id}`,
        category: 'Organization'
      }
    ]
  }, [organization])

  function onSelect(item: Command) {
    if (item.id === 'organization-id') {
      onCopyOrganizationId(organization.id)
      onClose()
    }
  }

  return (
    <CommandPaletteDialog
      className="w-1/3"
      onClose={onClose}
      onSelect={onSelect}
      commands={commands}
    />
  )
}
